<!-- 木桶结构缩微图单行组件-->
<template>
  <div :style="imgStyle">
    <ul
      style="margin-block-start: 0em;"
      id="boxList"
      :class="isLastArray ? 'class-start' : 'class-center'"
    >
      <li
        v-for="ibean in swImgs"
        v-bind:key="ibean.id"
        :class="{ lastRow: isLastArray }"
      >
        <imgbox
          :iHeight="destHeight"
          :id="ibean.id"
          :iname="ibean.iname"
          :isrc="ibean.isrc"
          :idraw="ibean.idraw"
          :imark="ibean.imark"
          :pos="ibean.pos"
          :len="ibean.len"
          :posSrc="ibean.posSrc"
          :lenSrc="ibean.lenSrc"
          :label="ibean.label"
          :level="ibean.level"
          :iClass="ibean.iClass"
          :titleG="ibean.titleG"
          :clearBG="ibean.clearBG"
          :boxRole="rowRole"
        ></imgbox>
      </li>
    </ul>
  </div>
</template>

<script>
import imgbox from './rely/iBoxInInRow'
export default {
  props: {
    rowRole: Number, // 类型 1:分类检索类型列表  2：同组名查找列表
    swImgs: Array,
    isLastArray: Boolean
  },
  components: {
    imgbox: imgbox
  },
  data () {
    return {
      imageSpan: 20, // 图片格子之间的间距
      canvasWidth: 1000, // 父容器的宽度
      swSrcHeight: 200, // 缩微图原始高度
      destHeight: 200
    }
  },
  methods: {
    resetImagesHeight () {
      // 为了让各行图片之间间距相同 这里重新设置单独每行的图片高度

      // console.log(this.isLastArray)
      // 该行只有一张图 而且很长 则调整这张图的高度让它适应父框
      const iCount = this.swImgs.length
      if (iCount === 1) {
        // 这行只有一张图
        const iw = this.swImgs[0].iwith // 这张图的宽度
        const panW = this.$el.clientWidth
        if (iw > panW) {
          const radio = parseFloat(iw) / parseFloat(panW)
          this.destHeight = Math.floor(parseFloat(this.swSrcHeight) / radio) // 最终本行的图片统一高度
        }
        return // 当地理里面最长的那副图在搜索的结果中间展示的时候需要
      }

      if (this.isLastArray) {
        return
      }

      this.canvasWidth = this.$el.clientWidth
      const imgsCanvasWidth = this.canvasWidth - iCount * this.imageSpan // 实际图片占用的宽度

      let imgsWidth = 0
      this.swImgs.forEach(ele => {
        imgsWidth = imgsWidth + parseInt(ele.iwith)
      })

      const radio = parseFloat(imgsCanvasWidth) / parseFloat(imgsWidth)

      this.destHeight = parseFloat(this.swSrcHeight) * radio // 最终本行的图片统一高度
      // 开始设置当前行高度

      // console.log(this.destHeight)
    }
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted () {
    this.resetImagesHeight() // 开始计算高度
  },
  computed: {
    imgStyle () {
      return {
        height: this.destHeight + 'px'
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

#boxList {
  display: flex;
}

.class-center {
  display: flex;
  justify-content: space-between;
}
.class-start {
  display: flex;
  justify-content: flex-start;
}

.lastRow {
  display: inline-block;
  margin-right: 20px;
}
#boxList li {
  list-style: none;
  /*  width: 150px; */
}

ul {
  height: 100%;
  padding-inline-start: 4px;
}
</style>
